//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from "vuex";
import StockValueTableWidget from '@/Widgets/StockValueTableWidget.vue';

export default {
  name: 'StockValueDialogWidget',
  components: { StockValueTableWidget },
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      visible: this.value,
      selectedWarehouse: null,
      loading: false,
      filter: '',
      selectedDate: null,
      totalValue: '0',
      totalWeightedValue: '0'
    };
  },
  computed: {
    ...mapState("main", ["warehouses"]),
  },

  watch: {
    value(newVal) {
      this.visible = newVal;
      if (!newVal) return;
      this.$nextTick(async () => {
        if (!this.$refs.table || !this.$refs.table.fetchData) return;
        this.loading = true;
        await this.$refs.table.fetchData()
        this.loading = false;
      });
    },
    visible(newVal) {
      this.$emit('input', newVal);
    }
  },
  methods: {
    ...mapActions("main", [
      "exportStockValue"
    ]),

    onTotalValue(val) {
      this.totalValue = new Intl.NumberFormat('no-NO', { minimumFractionDigits: 2 }).format(val);
    },
    onTotalWeightedValue(val) {
      this.totalWeightedValue = new Intl.NumberFormat('no-NO', { minimumFractionDigits: 2 }).format(val);
    },
    async exportExcel() {
        if (!this.$refs.table) return;

        const notif = this.$q.notify({
            message: this.$t("common.downloading"),
            timeout: 0,
            spinner: true,
        });

        const params = {
            searchQuery: this.$refs.table.searchQuery,
            sortBy: this.$refs.table.pagination.sortBy,
            sortDescending: this.$refs.table.pagination.descending,
            warehouseId: this.selectedWarehouse,
            datetime: this.selectedDate
        };

        var res = await this.exportStockValue(params);
        console.log({res})
        notif();

        const url = window.URL.createObjectURL(new Blob([res], { 
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
        }));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "stock-value.xlsx");

        document.body.appendChild(link);
        link.click();
    },
    closeDialog() {
      this.visible = false;
    }
  }
};
